export const nl = {
  // Common
  // Days of the week
  days: {
    monday: 'maandag',
    tuesday: 'dinsdag',
    wednesday: 'woensdag',
    thursday: 'donderdag',
    friday: 'vrijdag',
    saturday: 'zaterdag',
    sunday: 'zondag',
    sun: 'zo',
    mon: 'ma',
    tue: 'di',
    wed: 'wo',
    thu: 'do',
    fri: 'vr',
    sat: 'za',
  },

  // Months
  months: {
    january: 'januari',
    february: 'februari',
    march: 'maart',
    april: 'april',
    may: 'mei',
    june: 'juni',
    july: 'juli',
    august: 'augustus',
    september: 'september',
    october: 'oktober',
    november: 'november',
    december: 'december',
  },

  common: {
    save: 'Opslaan',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    edit: 'Bewerken',
    add: 'Toevoegen',
    close: 'Sluiten',
    loading: 'Laden...',
    error: 'Fout',
    success: 'Succes',
    confirm: 'Bevestigen',
    yes: 'Ja',
    no: 'Nee',
    search: 'Zoeken',
    filter: 'Filteren',
    clear: 'Wissen',
    apply: 'Toepassen',
    reset: 'Resetten',
    back: 'Terug',
    next: 'Volgende',
    previous: 'Vorige',
    first: 'Eerste',
    last: 'Laatste',
    today: 'Vandaag',
    export: 'Exporteren',
    import: 'Importeren',
    download: 'Downloaden',
    upload: 'Uploaden',
    copy: 'Kopiëren',
    copied: 'Gekopieerd',
    expand: 'Uitklappen',
    collapse: 'Inklappen',
    show: 'Tonen',
    hide: 'Verbergen',
    settings: 'Instellingen',
    language: 'Taal',
    colleague: 'Collega',
    year: 'Jaar',
    site: 'Site',
    saving: 'Opslaan...',
    deleting: 'Verwijderen...',
    startDate: 'Startdatum',
    endDate: 'Einddatum',
    legend: 'Legenda'
  },

  // Authentication
  auth: {
    signIn: 'Inloggen',
    signOut: 'Uitloggen',
    signUp: 'Registreren',
    email: 'E-mailadres',
    password: 'Wachtwoord',
    site: 'Site',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    mobile: 'Mobiel',
    signInToAccount: 'aanmelden',
    invalidCredentials: 'ongeldige inloggegevens',
    registrationFailed: 'registratie mislukt',
    loginFailed: 'Inloggen mislukt',
    signingIn: 'Inloggen...',
    loginRequired: 'U moet ingelogd zijn om verlof aan te vragen',
    authenticationRequired: 'U moet ingelogd zijn om deze functie te gebruiken',
    loginSection: 'Mijn kalender',
    changePassword: 'Wachtwoord wijzigen',
    currentPassword: 'Huidig wachtwoord',
    newPassword: 'Nieuw wachtwoord',
    confirmPassword: 'Bevestig wachtwoord',
    passwordChanged: 'Wachtwoord succesvol gewijzigd',
    passwordChangeFailed: 'Wachtwoord wijzigen mislukt',
    passwordsDontMatch: 'Wachtwoorden komen niet overeen',
    passwordTooShort: 'Wachtwoord moet minimaal 8 tekens bevatten',
    passwordMinLength: 'Minimaal 8 tekens',
    passwordUppercase: 'Eén hoofdletter',
    passwordNumber: 'Eén cijfer',
    passwordSpecialChar: 'Eén speciaal teken',
    passwordMatch: 'Wachtwoorden komen overeen',
    passwordsRequired: 'Huidig en nieuw wachtwoord zijn verplicht',
    incorrectPassword: 'Huidig wachtwoord is onjuist',
    userNotFound: 'Gebruiker niet gevonden',
    mustChangePassword: 'Wijzig uw wachtwoord',
    mustChangePasswordMessage: 'Om veiligheidsredenen moet u uw wachtwoord wijzigen voordat u verder gaat.',
    emailRequired: 'E-mail is verplicht',
    passwordRequired: 'Wachtwoord is verplicht',
    siteRequired: 'Site is verplicht',
  },

  // Calendar
  calendar: {
    calendar: 'Kalender',
    goToToday: 'Ga naar vandaag',
    previousWeek: 'Vorige week',
    nextWeek: 'Volgende week',
    previousMonth: 'Vorige maand',
    nextMonth: 'Volgende maand',
    previousYear: 'Vorig jaar',
    nextYear: 'Volgend jaar',
    openMonthPicker: 'Maandkiezer openen',
    closeMonthPicker: 'Maandkiezer sluiten',
    weekNumber: 'Week {{number}}',
    addEvent: 'Gebeurtenis toevoegen',
    editEvent: 'Gebeurtenis bewerken',
    eventDetails: 'Details',
    deleteEvent: 'Gebeurtenis verwijderen',
    createHoliday: 'Klik om verlof aan te maken voor week {{week}} ({{startDate}} - {{endDate}})',
    deleteHoliday: 'Klik om verlof te verwijderen voor week {{week}} ({{startDate}} - {{endDate}})',
    available: 'Beschikbaar',
    unavailable: 'Niet beschikbaar',
    weekend: 'Weekend',
    holiday: 'Verlof',
    requestedLeave: 'Verlof aanvraag',
    approvedHoliday: 'Verlof (OK)',
    deniedHoliday: 'Verlof geweigerd',
    pendingHoliday: 'Verlof in behandeling',
    requestedDesiderata: 'Aangevraagde desiderata',
    requestedPeriod: 'Periode aanvraag',
    eventCreated: 'Gebeurtenis succesvol aangemaakt',
    eventUpdated: 'Gebeurtenis succesvol bijgewerkt',
    eventDeleted: 'Gebeurtenis succesvol verwijderd',
    failedToCreateEvent: 'Aanmaken van gebeurtenis mislukt',
    failedToUpdateEvent: 'Bijwerken van gebeurtenis mislukt',
    failedToDeleteEvent: 'Verwijderen van gebeurtenis mislukt',
    dateNotAvailable: 'Datum niet beschikbaar',
    onDuty: 'Wacht',
    noOnDutyStaff: 'Geen radioloog van wacht toegewezen',
    showMobile: 'Toon mobiel nummer',
  },

  // Events
  events: {
    title: 'Titel',
    description: 'Beschrijving',
    date: 'Datum',
    startDate: 'Startdatum',
    endDate: 'Einddatum',
    type: 'Type',
    status: 'Status',
    pending: 'In behandeling',
    approved: 'OK',
    denied: 'Geweigerd',
    duration: 'Duur: {{days}} dagen',
    untitledEvent: 'Gebeurtenis zonder titel',
    noDescription: 'Geen beschrijving',
    enterTitle: 'Voer {{type}} titel in',
    enterDescription: 'Voer {{type}} beschrijving in',
    eventType: 'Gebeurtenistype',
    periodStatus: 'Periodestatus',
    holidayRequestsOpen: 'Vakantieaanvragen zijn open ({{period}})',
    holidayDesiderataOpen: 'Verlof- en desiderata-aanvragen zijn open ({{period}})',
    periodClosed: 'Periode is gesloten voor aanvragen ({{period}})',
    unknownStatus: 'Onbekende status ({{period}})',
    noEventTypesAvailable: 'Geen gebeurtenistypes beschikbaar',
    periodClosedMessage: 'Deze datum valt in een gesloten periode. Het aanmaken van gebeurtenissen is niet toegestaan.',
    cascadedSystem: 'Cascade systeem: Vakantieaanvragen hebben prioriteit boven desiderata',
    saving: 'Opslaan...',
    deleting: 'Verwijderen...',
    changesSaved: 'Wijzigingen succesvol opgeslagen',
    failedToSave: 'Opslaan van wijzigingen mislukt',
    modifyDates: 'Datums wijzigen',
    extendPeriod: 'Uitbreiden met weekenden',
    dateModificationNote: 'Wijzigingen worden direct toegepast na opslaan.',
    confirmDelete: 'Verwijderen bevestigen',
    deleteWarning: 'Deze actie kan niet ongedaan worden gemaakt.',
    createForColleague: 'Maak een gebeurtenis voor een collega',
    selectAtLeastOneTimeSlot: 'Selecteer ten minste één tijdslot',
    editApprovedEvent: 'Goedgekeurd evenement bewerken',
    editApprovedEventWarning: 'Deze gebeurtenis is goedgekeurd. U kunt alleen de titel en beschrijving wijzigen. Wijzigingen moeten worden gecontroleerd.',
    proceedToEdit: 'Doorgaan met bewerken',
  },

  // Users
  users: {
    userManagement: 'Gebruikersbeheer',
    addUser: 'Gebruiker toevoegen',
    editUser: 'Gebruiker bewerken',
    deleteUser: 'Gebruiker verwijderen',
    firstName: 'Voornaam',
    lastName: 'Achternaam',
    email: 'E-mail',
    role: 'Rol',
    status: 'Status',
    admin: 'Beheerder',
    user: 'Gebruiker',
    active: 'Actief',
    inactive: 'Inactief',
    actions: 'Acties',
    searchUsers: 'Gebruikers zoeken...',
    allRoles: 'Alle rollen',
    allStatus: 'Alle statussen',
    deleteConfirmation: 'Weet u zeker dat u {{name}} wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    cannotDeleteLastAdmin: 'Kan de laatste beheerder niet verwijderen',
    userCreated: 'Gebruiker succesvol aangemaakt',
    userUpdated: 'Gebruiker succesvol bijgewerkt',
    userDeleted: 'Gebruiker succesvol verwijderd',
    failedToCreateUser: 'Aanmaken van gebruiker mislukt',
    failedToUpdateUser: 'Bijwerken van gebruiker mislukt',
    failedToDeleteUser: 'Verwijderen van gebruiker mislukt',
    passwordRequirements: 'Wachtwoord moet minimaal 8 tekens bevatten en ten minste één hoofdletter, één cijfer en één speciaal teken hebben',
    leaveBlankToKeep: '(laat leeg om huidige te behouden)',
    page: 'Pagina {{current}} van {{total}}',
    unknownUser: 'Onbekende gebruiker',
    selectColleague: 'Selecteer een collega',
  },

  // Settings
  settings: {
    settings: 'Instellingen',
    colleagues: 'Collega\'s',
    admin: 'Beheerder',
    display: 'Weergave',
    manageUsers: 'Gebruikers beheren',
    manageColleagueDisplay: 'Collega-weergave beheren',
    changeIndividualAvailability: 'Beschikbaarheid aanpassen',
    subscribeToCalendar: 'Abonneren op kalender',
    exportEvents: 'Gebeurtenissen exporteren',
    definePeriods: 'Periodes definiëren/bewerken',
    exportAllData: 'Alle gegevens exporteren (ZIP)',
    reports: 'Rapporten',
    weekStartsOn: 'Week begint op:',
    showWeekNumber: 'Weeknummer tonen:',
    showWeekends: 'Weekenden tonen',
    showWerklijsten: 'Mijn programma tonen',
    showColleagueHolidayRequests: 'Verlof aanvraag collega\'s tonen',
    left: 'Links',
    right: 'Rechts',
    none: 'Geen',
    colleagueDisplaySettings: 'Collega-weergave instellingen',
    abbreviation: 'Afkorting',
    color: 'Kleur',
    hideColleague: 'Collega verbergen',
    showColleague: 'Collega tonen',
    editInitials: 'Initialen bewerken',
    clickToEditInitials: 'Klik om initialen te bewerken',
    failedToUpdateSettings: 'Bijwerken van instellingen mislukt',
    orderUpdated: 'Collega-volgorde succesvol bijgewerkt',
    failedToUpdateOrder: 'Bijwerken van collega-volgorde mislukt',
  },

  // Availability
  availability: {
    setAvailability: 'Beschikbaarheid',
    setAvailabilityFor: 'Beschikbaarheid voor {{firstname}} {{lastname}}',
    weeklySchedule: 'Weekschema',
    evenWeeks: 'Even weken',
    oddWeeks: 'Oneven weken',
    everyWeek: 'Elke week',
    alternateWeeks: 'Afwisselende weken',
    repeatPattern: 'Herhalingspatroon',
    addScheduleBefore: 'Schema toevoegen voor',
    addScheduleAfter: 'Schema toevoegen na',
    splitSchedule: 'Schema splitsen',
    deleteSchedule: 'Schema verwijderen',
    extendPrecedingSchedule: 'Voorgaand schema uitbreiden',
    extendFollowingSchedule: 'Volgend schema uitbreiden',
    firstSchedule: 'Eerste schema',
    previousSchedule: 'Vorig schema',
    nextSchedule: 'Volgend schema',
    lastSchedule: 'Laatste schema',
    newSchedule: 'Nieuw',
    addNewSchedule: 'Nieuw schema toevoegen',
    splitDate: 'Splitsdatum',
    endDateForCurrentSchedule: 'Einddatum voor huidig schema',
    newScheduleWillStart: 'Het nieuwe schema begint op {{date}}',
    selectDateBetween: 'Selecteer een datum tussen {{start}} en {{end}} om het schema te splitsen.',
    availabilityReport: 'Beschikbaarheidsrapport',
    availabilityReportFor: 'Beschikbaarheidsrapport voor {{name}} - {{year}}',
    viewReport: 'Rapport bekijken',
    viewCalendarReport: 'Kalenderrapport',
    clickToToggle: 'Klik op tijdslots om individuele updates te schakelen. Wijzigingen worden automatisch opgeslagen.',
    availabilityUpdated: 'Beschikbaarheid bijgewerkt',
    failedToUpdateAvailability: 'Bijwerken van beschikbaarheid mislukt',
    morning: 'Ochtend',
    afternoon: 'Middag',
    am: 'voormiddag',
    pm: 'namiddag',
    toggleAvailability: '{{day}} {{period}} beschikbaarheid schakelen',
    timeSlots: 'Tijdslot',
    reportLoaded: 'Rapport succesvol geladen',
    failedToCreateSchedule: 'Aanmaken van schema mislukt',
    failedToUpdateSchedule: 'Bijwerken van schema mislukt',
    failedToDeleteSchedule: 'Verwijderen van schema mislukt',
  },

  // Export
  export: {
    exportEvents: 'Gebeurtenissen exporteren',
    exportType: 'Exporttype',
    allEvents: 'Alle gebeurtenissen',
    myEventsOnly: 'Alleen mijn gebeurtenissen',
    startDateOptional: 'Startdatum (optioneel)',
    endDateOptional: 'Einddatum (optioneel)',
    leaveDatesEmpty: 'Laat datums leeg om alle gebeurtenissen te exporteren. Als u een datumbereik opgeeft, worden alleen gebeurtenissen binnen dat bereik geëxporteerd.',
    exporting: 'Exporteren...',
    preparingExport: 'Uw exportbestand wordt voorbereid...',
    exportDownloaded: 'Exportbestand succesvol gedownload!',
    failedToExport: 'Exporteren van gebeurtenissen mislukt. Probeer het opnieuw.',
  },

  // Subscription
  subscription: {
    calendarSubscription: 'Kalenderabonnement',
    subscribeToYourCalendar: 'Abonneren op uw kalender',
    subscriptionInstructions: 'Gebruik deze URL om u te abonneren op uw kalender in uw favoriete kalendertoepassing:',
    copyUrl: 'URL kopiëren',
    instructionsFor: 'Instructies voor {{app}}',
    outlook: 'Microsoft Outlook',
    googleCalendar: 'Google Calendar',
    appleCalendar: 'Apple Calendar',
    otherApplications: 'Andere toepassingen',
    outlookInstructions: [
      'Open Outlook Desktop of Outlook Web',
      'Klik met de rechtermuisknop op Kalender in het navigatievenster',
      'Selecteer "Kalender toevoegen" → "Van internet"',
      'Plak de abonnements-URL',
      'Klik op "OK" of "Opslaan"',
      'Kies hoe vaak Outlook de kalender moet synchroniseren',
      'Klik op "Ja" om de kalender toe te voegen'
    ],
    googleInstructions: [
      'Open Google Calendar in uw browser',
      'Zoek aan de linkerkant "Andere kalenders" en klik op de "+" knop',
      'Selecteer "Van URL" uit het dropdown menu',
      'Plak de abonnements-URL in het "URL" veld',
      'Klik op "Kalender toevoegen"',
      'De kalender verschijnt onder "Andere kalenders" in uw kalenderlijst'
    ],
    appleInstructions: [
      'Open de Kalender app op uw Mac',
      'Selecteer Bestand in de menubalk',
      'Kies "Nieuw kalenderabonnement"',
      'Plak de abonnements-URL',
      'Klik op "Abonneren"',
      'Configureer synchronisatiefrequentie en andere opties naar wens',
      'Klik op "OK" om te voltooien'
    ],
    appleIosInstructions: [
      'Ga naar Instellingen → Kalender → Accounts',
      'Tik op "Account toevoegen" → "Overig" → "Geabonneerde kalender toevoegen"',
      'Plak de abonnements-URL',
      'Tik op "Volgende" en dan op "Bewaren"'
    ],
    otherInstructions: [
      'Zoek naar een optie om een kalenderabonnement toe te voegen of "Abonneren op kalender"',
      'Wanneer gevraagd, plak de hierboven verstrekte abonnements-URL',
      'Configureer synchronisatiefrequentie als de optie beschikbaar is',
      'Bewaar of bevestig het abonnement'
    ],
    icalNote: 'Opmerking: De kalender gebruikt het iCalendar (.ics) formaat, dat compatibel is met de meeste moderne kalendertoepassingen.',
    failedToFetchUrl: 'Ophalen van abonnements-URL mislukt',
  },

  // Periods
  periods: {
    periodManagement: 'Periodebeheer',
    addPeriod: 'Periode toevoegen',
    editPeriod: 'Periode bewerken',
    deletePeriod: 'Periode verwijderen',
    resetToDefaults: 'Terugzetten naar standaard',
    saveChanges: 'Wijzigingen opslaan',
    nameLabel: 'Naam/Label',
    editingStatus: 'Bewerkingsstatus',
    closed: 'Gesloten',
    openHoliday: 'Open - Verlof',
    openDesiderata: 'Open - Desiderata',
    defaultClosed: 'Standaard: Gesloten',
    enterPeriodName: 'Voer periodenaam in',
    updatePeriod: 'Periode bijwerken',
    noPeriodsForYear: 'Geen periodes gedefinieerd voor {{year}}. Klik op "Periode toevoegen" om te beginnen.',
    resetConfirmation: 'Weet u zeker dat u wilt terugzetten naar standaardperiodes? Dit overschrijft alle huidige periodes.',
    periodsSaved: 'Periodes succesvol opgeslagen',
    periodsReset: 'Periodes teruggezet naar standaard',
    failedToSavePeriods: 'Opslaan van periodes mislukt',
    failedToResetPeriods: 'Terugzetten van periodes mislukt',
    failedToLoadPeriods: 'Laden van periodes mislukt',
    colleagueOrder: 'Collega-volgorde',
    dragToReorder: 'Sleep om te herordenen ({{count}} collega\'s)',
    noColleaguesAvailable: 'Geen collega\'s beschikbaar',
    manageColleagueOrder: 'Collega-volgorde beheren',
    validationErrors: {
      nameRequired: 'Naam is verplicht',
      startDateRequired: 'Startdatum is verplicht',
      endDateRequired: 'Einddatum is verplicht',
      endDateAfterStart: 'Einddatum moet na startdatum zijn',
      overlappingDates: 'Periodedatums overlappen met bestaande periode',
      periodsOverlap: 'Periodes "{{period1}}" en "{{period2}}" hebben overlappende datums',
    },
  },

  // Connection Status
  connection: {
    connected: 'Verbonden met real-time updates',
    disconnected: 'Verbinding verbroken met real-time updates',
    lostConnection: 'Verbinding verloren met real-time updates',
    reconnecting: 'Poging tot herverbinding...',
  },

  // Notifications
  notifications: {
    eventCreatedByColleague: 'Gebeurtenis {{action}} door collega',
    colleagueUpdatedAvailability: 'Collega heeft beschikbaarheid bijgewerkt',
    userConnected: 'Gebruiker verbonden',
    userDisconnected: 'Gebruiker verbinding verbroken',
    requestApproved: 'Aanvraag succesvol goedgekeurd',
    requestDenied: 'Aanvraag succesvol geweigerd',
    failedToApprove: 'Goedkeuren van aanvraag mislukt',
    failedToDeny: 'Weigeren van aanvraag mislukt',
    updatedEvents: '{{count}} gebeurtenissen bijgewerkt',
    failedToUpdateEvents: 'Bijwerken van gebeurtenissen mislukt',
  },

  // Admin Holiday Modal
  adminHoliday: {
    requestManagement: 'Aanvraagbeheer',
    adminReview: 'Beheerdersbeoordeling',
    employeeInformation: 'Werknemersinformatie',
    currentStatus: 'Huidige status',
    requestType: 'Aanvraagtype',
    dateRange: 'Datumbereik',
    requestDetails: 'Aanvraagdetails',
    submissionInfo: 'Ingediend op {{date}}',
    lastUpdated: 'Laatst bijgewerkt op {{date}}',
    approveRequest: 'Aanvraag goedkeuren',
    denyRequest: 'Aanvraag weigeren',
    processing: 'Verwerken...',
    clickToManage: 'Klik om {{name}}\'s aanvraag te beheren',
    clickToViewDetails: 'Klik om details te bekijken',
  },

  // Desiderata
  desiderata: {
    desiderataDays: 'Desiderata',
    workingDays: 'Werkdagen',
    weekendDays: 'Weekenddagen',
    remaining: 'Resterend',
    priority: 'Prioriteit',
    limitExceeded: 'Selectielimiet overschreden',
    approachingLimit: 'Naderende selectielimiet',
    totalAvailable: 'Totaal beschikbaar',
    publicHolidays: 'Feestdagen',
    mandatoryExtension: 'Selectie uitgebreid vanwege verplichte weekendregels',
    autoExtendedToWeekend: 'Selectie automatisch uitgebreid tot het weekend',
  },

  // Version Display
  version: {
    systemInformation: 'Systeeminformatie',
    frontend: 'Frontend',
    backend: 'Backend',
    version: 'Versie:',
    buildDate: 'Bouwdatum:',
    environment: 'Omgeving:',
    targetUrl: 'Doel-URL:',
    status: 'Status:',
    uptime: 'Uptime:',
    lastCheck: 'Laatste controle:',
    refreshHealthCheck: 'Gezondheidscontrole vernieuwen',
    checking: 'Controleren...',
    production: 'productie',
    development: 'ontwikkeling',
    healthy: 'gezond',
    error: 'Fout',
  },


  // Error messages
  errors: {
    somethingWentWrong: 'Er is iets misgegaan',
    failedToLoadData: 'Laden van gegevens mislukt',
    networkError: 'Netwerkfout',
    unauthorized: 'Niet geautoriseerd',
    forbidden: 'Verboden',
    notFound: 'Niet gevonden',
    internalServerError: 'Interne serverfout',
    validationError: 'Validatiefout',
    unknownError: 'Onbekende fout',
  },

  // Public holidays
  publicHolidays: {
    newYearsDay: 'Nieuwjaarsdag',
    easterSunday: 'Paaszondag',
    easterMonday: 'Paasmaandag',
    labourDay: 'Dag van de Arbeid',
    ascensionDay: 'Hemelvaartsdag',
    whitSunday: 'Pinksteren',
    whitMonday: 'Pinkstermaandag',
    belgianNationalDay: 'Belgische Nationale Feestdag',
    assumptionDay: 'Maria-Tenhemelopneming',
    allSaintsDay: 'Allerheiligen',
    armisticeDay: 'Wapenstilstand',
    christmasDay: 'Kerstmis',
    goodFriday: 'Goede Vrijdag',
    earlyMayBankHoliday: 'Vroege mei-feestdag',
    springBankHoliday: 'Lentefeestdag',
    summerBankHoliday: 'Zomerfeestdag',
    boxingDay: 'Tweede Kerstdag',
  },

  // Documents
  documents: {
    downloadSchedule: 'Dienstrooster downloaden (PDF)',
    downloadFailed: 'Download mislukt. Probeer het opnieuw.',
    invalidFileType: 'Ongeldig bestandstype. Alleen PDF-bestanden zijn toegestaan.',
    invalidFilename: 'Ongeldige bestandsnaam.',
    fileNotFound: 'Document niet gevonden.',
    failedToDownload: 'Downloaden van document mislukt.',
    failedToListDocuments: 'Ophalen van documentenlijst mislukt.',
  },

  // Reports
  reports: {
    desiderata: 'Desiderata',
    desiderataReport: 'Desiderata Rapport',
    desiderataReportDescription: 'Desiderata-gegevens exporteren naar Excel',
    desiderataReportInstructions: 'Selecteer een jaar en periode om een Excel-rapport te genereren met desiderata-aanvragen van alle teamleden.',
    availability: 'Beschikbaarheid',
    availabilityReport: 'Beschikbaarheidsrapport',
    availabilityReportDescription: 'Team beschikbaarheidsschema\'s exporteren naar Excel',
    availabilityReportInstructions: 'Genereer een Excel-rapport met werkschema\'s en beschikbaarheid van alle teamleden.',
    aggregatedAvailability: 'Geaggregeerde Beschikbaarheid',
    aggregatedAvailabilityDescription: 'Niet-beschikbare teamleden per datum exporteren',
    aggregatedAvailabilityInstructions: 'Genereer een Excel-rapport met welke teamleden niet beschikbaar zijn per datum/periode.',
    unavailableUsers: 'Niet-beschikbare Gebruikers',
    aggregatedLeave: 'Geaggregeerd Verlof',
    aggregatedLeaveDescription: 'Teamleden met verlof per datum exporteren',
    aggregatedLeaveInstructions: 'Genereer een Excel-rapport met welke teamleden verlof hebben per datum/periode.',
    usersOnLeave: 'Gebruikers met verlof',
    period: 'Periode',
    date: 'Datum',
    total: 'Totaal',
    selectPeriod: 'Selecteer een periode',
    noDataAvailable: 'Geen gegevens beschikbaar voor de geselecteerde periode',
    noPeriodsAvailable: 'Geen periodes beschikbaar',
    exporting: 'Exporteren...',
    exportToExcel: 'Exporteren naar Excel',
    exportSuccess: 'Rapport succesvol geëxporteerd',
    exportFailed: 'Exporteren van rapport mislukt. Probeer het opnieuw.',
  },
};